import { classNames } from 'shared/lib/classNames/classNames';
import React from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import img from 'shared/assets/img/pages/girl-image.png';
import cls from './Monologue.module.scss';

interface MonologueProps {
    className?: string,
    name: string,
    message: string,
    // imgUrl?: string,
}
export const Monologue = ({ className, name, message }: MonologueProps) => {
    console.log('Monologue');
    return (
        <div className={cls.container}>
            <div className={cls.messageBox}>
                <img src={img} className={cls.сharacterImg} alt="" />
                <div className={cls.name}>
                    {name}
                </div>
                <div className={cls.message}>
                    {message}
                </div>
                <Button className={cls.buttonNext} theme={ButtonTheme.NEXT}>
                    Далее
                </Button>
            </div>
        </div>
    );
};
